import {EntityContact} from "./EntityContact.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class ResourceContact extends EntityContact {
  static get $name() {
    return "ResourceContact";
  }

  static relations = {
    resourceRecord: { // this will get resource record of this record
      foreignKey: "resourceId",
      foreignStore: STORE_KEYS.resourceStore,
      relatedCollectionName: "contacts", // this key will be added to the parent to get child records -> resourceStore.first.contacts will bring all ResourceContact records for that resource record
    },
    contactRecord: { // this will get contact (detail) record of this record
      foreignKey: "contactId",
      foreignStore: STORE_KEYS.contactStore,
      relatedCollectionName: "resourceContacts", // this key will be added to the parent to get child records -> contactStore.first.resourceContacts will bring all ResourceContact records for that contact record
    }
  }

  static get fields() {
    return [
      { name: "resourceId", dataSource: "resource" },
    ];
  }
}

ResourceContact.exposeProperties();
